import { Injectable } from '@angular/core';
import { Cookie } from '../models/cookie';
import { MainService } from './main.service';

declare var gtag;

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private analyticsEnabled = false;

  constructor(private mainService: MainService) {
    this.mainService.cookieOption$.subscribe((cookie: Cookie) => {
      this.analyticsEnabled = !!cookie?.statistic;
    });
  }

  trackSearch(keyword: string): void {
    if (!this.analyticsEnabled || typeof gtag === 'undefined') {
      return;
    }
    gtag('event', 'search', { search_term: keyword });
  }
}
